import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import "./ChallengeBanner.css";

const MESSAGE = (
  <>
    🏆 TutorsLinks Educator Impact Challenge 2026 — ₦1,000,000 in cash prizes,
    10 winners of ₦100,000 each — Teach us something useful in 3 minutes —
    Apply now →
  </>
);

// Short, mobile-friendly version — the full scrolling message is too long
// for a single line on a phone screen, so this collapses to one concise
// line instead of wrapping or truncating mid-sentence.
const MOBILE_MESSAGE = "🏆 Educator Impact Challenge 2026 — ₦1,000,000 in prizes. Apply now →";

// Bump this when the campaign/copy changes so a previously-dismissed banner
// comes back for a genuinely new announcement instead of staying hidden
// forever based on an old dismissal.
const DISMISS_KEY = "challengeBannerDismissed:2026-educator-impact";

// Dismissible, in-flow announcement bar (NOT a fixed overlay — it used to be
// `position: fixed`, which took it out of document flow entirely and let it
// render on top of whatever happened to be underneath, overlapping the hero
// headline). Desktop/tablet gets the auto-scrolling marquee; mobile gets one
// static concise line instead, since a scrolling ticker is harder to read
// on a narrow screen.
const ChallengeBanner = () => {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === "1",
  );

  if (dismissed) return null;

  const handleDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div className="challenge-banner">
      <Link
        to="/award"
        className="challenge-banner-link"
        aria-label="View the TutorsLinks Educator Impact Challenge 2026"
      >
        <div className="challenge-banner-track">
          <span className="challenge-banner-item">{MESSAGE}</span>
          <span className="challenge-banner-item">{MESSAGE}</span>
          <span className="challenge-banner-item">{MESSAGE}</span>
          <span className="challenge-banner-item">{MESSAGE}</span>
        </div>
        <span className="challenge-banner-mobile-item">{MOBILE_MESSAGE}</span>
      </Link>
      <button
        type="button"
        className="challenge-banner-dismiss"
        onClick={handleDismiss}
        aria-label="Dismiss announcement"
      >
        <FaTimes size={14} />
      </button>
    </div>
  );
};

export default ChallengeBanner;
